export default {
    model: {
        email: {
            label: "Email",
            placeholder: "Meghatalmazott neve vagy e-mail címe",
            notFound: "Nem találhatók felhasználók"
        },
        start_on: {
            label: "Kezdő dátum",
            placeholder: "A delegálás kezdetének dátuma"
        },
        end_on: {
            label: "Befejezési dátum",
            placeholder: "Választható"
        },
        accept: {
            tip: "A jóváhagyási felelősség átruházásával Ön igazolja, hogy felelősséget vállal a megbízottja által jóváhagyott utasításokért.",
            label: "Elfogadom"
        }
    },
    buttons: {
        submit: {
            cta: "Megerősítés",
            processing: "Megtakarítás"
        },
        close: {
            cta: "Mégsem"
        }
    },
    saved: "Mentett"
}